import * as tslib_1 from "tslib";
import { compare, compareNumber } from '../../core/helpers/sorting';
var empty = {};
var emptyPredicate = function (result) { return result !== empty; };
var ɵ0 = emptyPredicate;
export function prepFacetGroups(groups) {
    return groups.reduce(function (dict, group) {
        var _a;
        return Object.assign(dict, (_a = {}, _a[group.code] = group, _a));
    }, {});
}
export function prepFacets(facets) {
    return facets.reduce(function (dict, facet) {
        var _a;
        var groupCode = facet.code.split('=')[0];
        return Object.assign(dict, (_a = {},
            _a[groupCode] = (dict[groupCode] || []).concat([
                facet
            ]),
            _a));
    }, {});
}
export function parseFromBaseline(groups, baseline, incomingCounts) {
    return groups.reduce(function (prev, curr) {
        var _a;
        var group = baseline[curr];
        return Object.assign(prev, (_a = {},
            _a[curr] = group.map(function (count) {
                var incoming = incomingCounts
                    .find(function (fc) { return fc._id === count._id; });
                return tslib_1.__assign({}, count, { count: (incoming && incoming.count) || 0 });
            }),
            _a));
    }, {});
}
export function applyOver(incoming) {
    var dict = {};
    if (!incoming)
        return dict;
    incoming.forEach(function (count) {
        var groupCode = count._id.split('=')[0];
        var entry = dict[groupCode];
        if (!entry)
            dict[groupCode] = entry = [];
        if (entry.indexOf(entry.find(function (obj) { return obj._id === count._id; })) < 0)
            entry.push(count);
    });
    return dict;
}
export function createUXFacets(facets, baseline, groupCode) {
    if (!baseline)
        return [];
    return facets.map(function (facetCount) {
        var facet = baseline.find(function (facet) { return facet.code === facetCount._id; });
        if (!facet)
            return empty;
        return {
            name: facet.name,
            code: facet.code.split('=')[1],
            count: facetCount.count,
            group: groupCode
        };
    })
        .filter(emptyPredicate)
        .sort(compare(function (facet) { return facet.name; }));
}
export function createUXFacetGroups(groupNames, groups, facets, facetCounts) {
    return groupNames.map(function (curr) {
        var facetsGrouping = facetCounts[curr];
        var baselineGrouping = facets[curr];
        var facetGroup = groups[curr];
        if (!facetsGrouping || !baselineGrouping || !facetGroup)
            return empty;
        return {
            name: facetGroup.name,
            code: curr,
            facets: createUXFacets(facetsGrouping, baselineGrouping, facetGroup.code),
            sortOrder: facetGroup.sortOrder
        };
    })
        .filter(emptyPredicate)
        .sort(compareNumber(function (group) { return group.sortOrder; }));
}
export function createUXFacetChips(groupnames, uxfacets, appliedFacets) {
    if (groupnames && groupnames.length > 0 && (uxfacets && uxfacets.length > 0) && (appliedFacets)) {
        return groupnames.reduce(function (prev, curr) {
            var applied = appliedFacets[curr];
            if (!applied)
                return prev;
            var group = uxfacets.find(function (group) { return group.code === curr; });
            applied.forEach(function (facetCode) {
                var facet = group.facets.find(function (f) { return f.code === facetCode; });
                if (!facet)
                    return;
                prev.push({
                    code: facet.code,
                    name: facet.name,
                    group: group.code,
                    groupName: group.name
                });
            });
            return prev;
        }, []).sort(compare(function (chip) { return chip.groupName; }));
    }
    return [];
}
export { ɵ0 };
